import { CompanionAvatar } from "./CompanionAvatar";
import type { Companion } from "./data";

export function CompanionPicker({
  companions,
  selectedId,
  onSelect,
}: {
  companions: Companion[];
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <aside className="picker-panel" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:14:5"}>
      <div className="panel-kicker" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:15:7"}>Твои собеседницы</div>
      <h2 data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:16:7"}>Выбери настроение</h2>
      <p className="panel-intro" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:17:7"}>У каждой — свой характер и свой взгляд на мир.</p>
      <div className="companion-list" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:18:7"}>
        {companions.map((companion) => {
          const selected = selectedId === companion.id;
          return (
            <button
              className={`companion-card ${selected ? "companion-card--selected" : ""}`}
              key={companion.id}
              onClick={() => onSelect(companion.id)}
             data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:22:13"}>
              <CompanionAvatar companion={companion} small data-amazi-jsx-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:27:15"} />
              <span className="companion-card__copy" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:28:15"}>
                <strong data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:29:17"}>{companion.name}</strong>
                <small data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:30:17"}>{companion.role}</small>
              </span>
              {selected && (
                <span className="selected-dot" aria-label="Выбрана" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:33:17"}>
                  ✓
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="privacy-note" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:41:7"}>
        <span data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:42:9"}>✦</span>
        <p data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:43:9"}>
          <strong data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:44:11"}>Твоё пространство</strong>
          <br data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionPicker.tsx:45:11"} />
          История хранится только в этом браузере.
        </p>
      </div>
    </aside>
  );
}
